import React, { useCallback, useLayoutEffect, useReducer } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { officeApi } from "../../../api/config";
import { AllianceInsertreducer } from "../../../interface/ActionReducer";
import { AllianceFixState } from "../../../lib/ReducerStates";
import { ToastChange } from "../../../reducers/config";
import { AllianceDataType } from "../../Alliance/Alliance";
import AllianceInsert from "../../AllianceInsert/AllianceInsert";

interface LocationType {
  state: AllianceDataType;
}

/** 제휴사 수정 페이지*/
const AllianceFixContainer = () => {
  const { state } = useLocation() as LocationType;
  const navigate = useNavigate();
  const reduxPatch = useDispatch();
  /** 제휴사 수정 데이터 */
  const [AllianceFixData, dispatch] = useReducer(
    AllianceInsertreducer,
    AllianceFixState
  );
  /** 제휴사 내용 수정 함수 */
  const FixAlliance = useCallback(() => {
    const { prtn_nm, prtn_use, prtn_info, prtn_desc, prtn_id, thumbnail } =
      AllianceFixData;
    officeApi
      .post("/cstm/prtn", {
        prtn_id,
        prtn_nm,
        prtn_use,
        prtn_info,
        prtn_desc,
        thumbnail,
      })
      .then(({ data: { sts_fg, err_msg } }) => {
        if (sts_fg) {
          reduxPatch(
            ToastChange({
              active: true,
              content: "제휴사 내용이 수정되었습니다",
            })
          );
          navigate(-1);
        } else {
          reduxPatch(
            ToastChange({
              active: true,
              content: err_msg,
            })
          );
        }
      })
      .catch(() => {
        reduxPatch(
          ToastChange({
            active: true,
            content: "네트워크 에러",
          })
        );
      });
  }, [navigate, reduxPatch, AllianceFixData]);
  useLayoutEffect(() => {
    const { prtn_nm, prtn_use, prtn_info, prtn_desc, prtn_id, thumbnail } =
      state;
    dispatch({
      type: "dispatch/all",
      payload: {
        prtn_id,
        prtn_nm,
        prtn_use,
        thumbnail,
        prtn_info,
        prtn_desc,
      },
      index: undefined,
    });
    return () => {};
  }, [state, dispatch]);
  return (
    <AllianceInsert
      type="fix"
      InsertData={FixAlliance}
      dispatch={dispatch}
      data={AllianceFixData}
    />
  );
};

export default AllianceFixContainer;
